module.exports = __webpack_public_path__ + "static/media/_img_saber_logo.5d372ac4.png";